import ActionTypes from "./action-types";

// refactor later and move to UDL API
const mapReduxToGTM = {};

export const STORE_TRACK_PREFIX = "-us:hho";
// map redux actions to GTM events
mapReduxToGTM[ActionTypes.ADD_TO_CART] = 'e_addToCart';
mapReduxToGTM[ActionTypes.REMOVE_FROM_CART] = 'e_removeFromCart';
mapReduxToGTM[ActionTypes.SORT_PRODUCTS] = 'e_facet';
mapReduxToGTM[ActionTypes.LOCATION_CHANGE] = 'e_pageView';
mapReduxToGTM[ActionTypes.TOGGLE_COMPARE_MODAL] = 'e_compareModels';
mapReduxToGTM[ActionTypes.RECEIVE_VARIANT_INFO] = 'e_linkClick';

export const GTM_EVENTS = Object.assign({}, mapReduxToGTM);

//map adobe eVar values to UDL parameters https://docs.google.com/document/d/16YPn5Byr7XS6S1A7yDiAPdihWujScyyuU_yE2t2Oix0
const eVarMap = {
	"evar75": "v151",
	"evar76": "v152",
	"evar77": "v153",
	"evar78": "v154",
	"evar79": "v155"
}

const getABTestParams = (testFlags, path) => {
	//for now just scane through redirect test to find the one matching the current URL
	try {
		const {
			redirects = [],
			ssrTest
		} = testFlags;
		let params = {};
		let decodedPath = decodeURIComponent(path)
		let ssrTestKeys = Object.keys(ssrTest);

		//find first match in either target or redstination in all redirects
		let abTest;

		for (let i = 0; i < redirects.length; i++) {
			//find first path match in either target or destination
			let test = redirects[i];
			var testTargets = Object.keys(test.targeting);
			for (let z = 0; z < testTargets.length; z++) {
				let target = decodeURIComponent(testTargets[z]);
				let destination = decodeURIComponent(test.targeting[target]);
				if (target === decodedPath || destination === decodedPath) {
					abTest = test;
					break;
				}
			}
			if (abTest) {
				break
			}
		}

		//only use provided evar tracking for now, could optional use testname and 
		//vartion which UDL autmatically sets for eVar25 - 27 (supports three test)
		if (abTest && abTest.action && abTest.action.tracking) {
			const { action: { tracking } } = abTest;
			//add evar valyes from tracking
			params = Object.keys(tracking).reduce((r, k) => {
				let udlVar = eVarMap[k.toLowerCase()];
				//only use range support by UDL
				if (udlVar) {
					r[udlVar] = tracking[k];
				}
				return r;
			}, {})
		}

		//currently no URL targeting for SSR test, just run through and apply eVars for active ssrTests
		if(ssrTestKeys && ssrTestKeys.length > 0){
			for(let i = 0; i < ssrTestKeys.length; i++){
				const key = ssrTestKeys[i];
				const test = ssrTest[key];
				const { action={} } = test;
				const { tracking={} } = action;
				//add evar valyes from tracking
				params = Object.keys(tracking).reduce((r, k) => {
					let udlVar = eVarMap[k.toLowerCase()];
					//only use range support by UDL
					if (udlVar) {
						r[udlVar] = tracking[k];
					}
					return r;
				}, params)
			}
		}

		return params;
	} catch (e) {
		return {};
	}

}

export function _addToCart(prds, currencyCode, orderId, metricParams) {
	let params = {
		'event': GTM_EVENTS[ActionTypes.ADD_TO_CART],
		'cartID': orderId,
		'ecommerce': {
			currencyCode,
	    	'add': {products: []},
		}
	};

	// add list of products into add array
	params.ecommerce.add.products = prds.map(({brand, category, id, name, price, quantity, xsellProdInfo, xsellMethod} = v) => ({category: `${category}:${brand}`, id, name, price, quantity, xsellProdInfo, xsellMethod }));

	try{
		if(metricParams && metricParams.list){
			params.ecommerce.add.detail = {
				actionField: {
					list: metricParams.list
				}
			}
		}
	}catch(e){}

  return params;
}

export function _removeFromCart(prds, currencyCode) {
    let params = {
		'event': GTM_EVENTS[ActionTypes.REMOVE_FROM_CART],
		'ecommerce': {
	    	'remove': {products: []},
	    }
	};

	// add list of products into remove array
	params.ecommerce.remove.products = prds.map(({id, name, price, quantity} = v) => ({id, name, price, quantity}));

    return params;
}

export function _productClick( params ){
	let _params = {
		'event': 'e_productClick',
		ecommerce: {
			click: {
				actionField: { },
				products: []
			}
		}
	};

	try{
		let {
			price,
			name,
			id,
			brand,
			category,
			position,
			list
		} = params;

		_params.ecommerce.click.actionField = {list};
		_params.ecommerce.click.products = [{
			price, name, 
			id, 
			brand, category, position
		}];
		
	}catch(e){}

	return _params;
}

export function _compare(compare_products){
	let concatProductIDs = compare_products.map((x) => x._id).join(',');
	let concatProductNames = compare_products.map((x) => x.name).join(',');
	return {
		'event': GTM_EVENTS[ActionTypes.TOGGLE_COMPARE_MODAL],
		concatProductIDs,
		concatProductNames
	}
}

export function _pageView(page, user, products, state={ router: { location: {} }}) {
	//add ab test params based on tests and current pathname
	let { testFlags, router: { location: { pathname }} } =state;
	let abTest = getABTestParams(testFlags, pathname);

	let params = {
		'event': GTM_EVENTS[ActionTypes.LOCATION_CHANGE], // required
		pageNameL5: page.pageNameL5, // page type
		pageNameL6: page.pageNameL6, // page category
		pageNameL7: page.pageNameL7, // page sub category
		// pageNameL8: page.pageNameL8,  	// page detailed category
		userTypeSession: user.tier,
		loginStatus: user.logged_in,
		pageBusinessUnit: page.businessUnit,
		callCenter: user.isCallCenter
	};

  // re-visit later
  const {urlParams = {}} = page;
	const {blogSearchTerm, nor} = urlParams;
  if(blogSearchTerm){
  	params.searchTerm = 'blog:' + blogSearchTerm;
  };
	if(nor) {
		params.numSearchResults = 'blog:number_of_results:' + nor;
	};

	if( products ){
		params.ecommerce = {
	    	'detail': {
	        	'actionField': {'list': `${ products[0].name }`},
	       	}
	    };

	  // add list of products into pageview array
		params.ecommerce.detail.products = products.map(({brand, category, id, name, price} = v) => ({category: `${category}:${brand}`, id, name, price}));

	}

	// get evar tracking params from Optimizely
	if (window.optimizely && typeof window.optimizely.get === 'function' && window.optimizely.get("custom/adobeIntegrator")){
	    window.optimizely.get("custom/adobeIntegrator").assignCampaigns(params);
	}
	//update mPulse dimensions
	if(page.templateKey){
		window.testConfig = page.templateKey;
	}

  return { ...params, ...abTest};
}

export function _sort(searchSortType){
	return {
		'event':GTM_EVENTS[ActionTypes.SORT_PRODUCTS],
		sortType: searchSortType
	};
}

export function _variantsSelection(variant){
	const { sku } = variant;
	const linkId = `variant-selected:${sku}`;
	return {
		'event':GTM_EVENTS[ActionTypes.RECEIVE_VARIANT_INFO],
		linkId,
	};
}

export const trackCustomMetric = (eventName, params) => (
	dispatch => (
		dispatch({ 
			type: ActionTypes.TRACK_CUSTOM_METRIC,
			payload: {
				eventName,
				params
			}
		})
	)
);

export const parseMetricParams = (eventName, params) => {
	switch(eventName){
		case 'productClick':{
			return _productClick(params);
		}
		default:
	}

	return params;
}